export const statusEnumSQ = {
  // all: 'All',
  new: 'Applicants',
  interview: 'Interview',
  low: 'Low',
  spxedu: 'Speeex Education',
  will_be_tested: 'Will be Tested',
  testing: 'Pending',
  waiting_list: 'Passed',
  failed: 'Failed',
  recruited: 'Recruited',
  declined: 'Refused',
  blacklist: 'Blacklist'
}
